const STORAGE_KEY = 'dark-theme-selected';

export function saveDarkTheme(val) {
  localStorage.setItem(STORAGE_KEY, val);
}

export function getSavedTheme() {
  return localStorage.getItem(STORAGE_KEY) === 'true';
}
